<template>
  <CContainer class="d-flex content-center min-vh-100">
    <b-row class="justify-content-center" no-gutters>
      <b-col>
        <b-card no-body class="p-4">
          <b-card-body>
            <b-form validated @submit.prevent="handleSigninUser" autocomplete="new-password">
              <h1>
                <i v-if="!user.avatarb64" class="fa fa-user pr-2"></i>
                <img v-if="user.avatarb64" class="img" slot="imageProfile" :src="user.avatarb64" />
                {{ user.firstname +' '+ user.lastname}}
              </h1>
              <p class="text-muted">Unlock your account</p>
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="fa fa-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="password"
                  id="normalPass"
                  required
                  v-model="password"
                  :disabled="busy"
                  placeholder="Enter Password"
                  autocomplete="new-password"
                />
                <b-form-invalid-feedback id="passwordFeedback">Password is required</b-form-invalid-feedback>
              </b-input-group>
              <b-alert v-if="error" variant="danger" show>{{error.message}}</b-alert>
              <b-row align-v="center" no-gutters>
                <b-col>
                  <b-button
                    type="submit"
                    variant="primary"
                    class="px-4"
                    @click="handleUnlockUser()"
                  >Unlock</b-button>&nbsp;
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LockAccount",
  data() {
    return {
      password: null
    };
  },
  methods: {
    handleUnlockUser() {
      if (this.password) {
        this.$router.push("/");
      }
    }
  },
  computed: {
    ...mapGetters(["busy","error","user"])
  }
};
</script>
